import React from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
  SettingsOptionHeading,
} from "../../styles";
import { ButtonGroup, NumberInput, Select } from "@caelor/ui";
import { useTranslation } from "react-i18next";
import { useRecentlyActiveStore } from "../../../../../../stores/use-recently-active-store";
import {
  BOOLEAN_OPTIONS,
  CORNERS_OPTIONS,
  getPaginationOptions,
} from "./defaults";

function LayoutSettings() {
  const { t } = useTranslation();

  const { data, updateData } = useRecentlyActiveStore((state) => ({
    data: state.data,
    updateData: state.updateData,
  }));

  const PaginationOptions = getPaginationOptions(t);

  return (
    <>
      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("display-options")}</SettingsOptionHeading>

        <OptionContainer>
          <OptionLabel>{t("pagination")}</OptionLabel>
          <OptionContent>
            <Select
              options={PaginationOptions}
              value={PaginationOptions.find(
                ({ value }) => value === data.pagination
              )}
              onChange={({ value }) =>
                updateData({ value: { pagination: value } })
              }
            />
          </OptionContent>
        </OptionContainer>

        <OptionContainer>
          <OptionLabel>{t("per-page")}</OptionLabel>
          <OptionContent>
            <NumberInput
              value={data.maxNumberOfItems}
              setValue={(value) =>
                updateData({ value: { maxNumberOfItems: value } })
              }
              min={1}
              isFullWidth
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>

      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("link")}</SettingsOptionHeading>
        <OptionContainer>
          <OptionLabel>{t("new-tab")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={BOOLEAN_OPTIONS}
              value={data?.openInNewTab ?? true}
              onClick={(isOn) =>
                updateData({
                  value: { openInNewTab: isOn },
                })
              }
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>

      <SettingsOptionContainer>
        <SettingsOptionHeading>{t("styling-options")}</SettingsOptionHeading>

        <OptionContainer>
          <OptionLabel>{t("corners")}</OptionLabel>
          <OptionContent>
            <ButtonGroup
              items={CORNERS_OPTIONS}
              value={data.borderRadius}
              options={{ input: true }}
              onClick={(value) =>
                updateData({ value: { borderRadius: value } })
              }
              onChange={({ target: { value } }) => {
                if (value.length < 4) {
                  updateData({ value: { borderRadius: value } });
                }
              }}
              i18n={t}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default LayoutSettings;
